import { ChangeColor } from './ChangeColor';

export class ChangeLinkColor extends ChangeColor {
  type: string = 'ChangeLinkColor';
}
